module.exports = __webpack_public_path__ + "static/media/Gold-hoops.2d90905f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/jewellery/Gold-hoops.png
// module id = 235
// module chunks = 0